import { ValueError } from "../error/ValueError.js";
/** Function that always returns undefined. */
export const getUndefined = () => undefined;
/** Is a value undefined? */
export function isUndefined(value) {
    return value === undefined;
}
/** Is a value defined? */
export function isDefined(value) {
    return value !== undefined;
}
/** Is a value defined? */
export const notUndefined = isDefined;
/** Assert that a value is not `undefined` */
export function assertDefined(value) {
    if (value === undefined)
        throw new ValueError("Must be defined", value);
}
/** Get a defined value. */
export function getDefined(value) {
    assertDefined(value);
    return value;
}
